import { useQuery } from '@gogame/query';

import { loadCohorts } from 'scenes/Trackers/Tracker/sources/metrics';

import { cohorts } from './queryKeyFactory';

export const useLoadCohortTable = ({ enabled, ...params }) =>
  useQuery(
    cohorts(params),
    (_, { signal }) => loadCohorts(params, { signal }),
    {
      initialData: {
        cols: [],
        rows: [],
      },
      enabled,
    }
  );
